export const displayTabNames: Record<string, string> = {
  All: "All",
  Pending: "Pending decision",
  Started: "In progress",
  Approved: "Approved",
  ApprovedConditionally: "Approved conditionally",
  Invited: "Invited",
  Declined: "Declined",
  Canceled: "Canceled",
  Submitted: "Submitted"
};
